export interface DecodedField {
  icon: string;
  colorClass: string;
  labelKey: string;
}

/**
 * Restituisce icona (lucchetto), classe colore e chiave i18n
 * in base al valore numerico di `datoMaggiorTutelaAnonimato`.
 *
 * | value | significato        | icona        |
 * |-------|--------------------|--------------|
 * | 1     | Oscurato           | lock         |
 * | 2     | Visibile solo SSN  | lock_open    |
 * | altro | Nessuna tutela     | no_encryption|
 */
export function getTutelaAnonimatoInfo(
  value: number | null | undefined
): DecodedField {
  switch (value) {
    case 1:
      return {
        icon: 'lock',
        colorClass: '!text-amber-600',
        labelKey: 'DOCUMENTI_DSE.tutela_oscurato',
      };
    case 2:
      return {
        icon: 'lock_open',
        colorClass: '!text-blue-600',
        labelKey: 'DOCUMENTI_DSE.tutela_ssn',
      };
    default:
      return {
        icon: 'no_encryption',
        colorClass: '!text-gray-400',
        labelKey: 'DOCUMENTI_DSE.tutela_visibile',
      };
  }
}
